import { ReactElement } from 'react'
import { useParams } from 'react-router'
import { ApplicationSummaryPage } from 'src/screens/shared/application/details/summary/ApplicationSummaryPage'

export const PfKapApplicationSummaryPage = (): ReactElement => {
  const { projectId } = useParams()

  return <ApplicationSummaryPage baseUrl="/pf-kap" projectId={parseInt(projectId as string)} />
}
